import { render, staticRenderFns } from "./LmNationalitySelector.vue?vue&type=template&id=88b4db6a&scoped=true"
import script from "./LmNationalitySelector.vue?vue&type=script&lang=js"
export * from "./LmNationalitySelector.vue?vue&type=script&lang=js"
import style0 from "./LmNationalitySelector.vue?vue&type=style&index=0&id=88b4db6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b4db6a",
  null
  
)

export default component.exports